import {
  getString,
  getObject,
} from "@surya-digital/leo-ts-types";
import { CommonResultBreakdownDetails, CommonResultBreakdownDetailsDTO } from "./commonResultBreakdownDetails";

export interface OpenEndedResultV1DTO {
  answer: string;
  commonResultBreakdownDetails: CommonResultBreakdownDetailsDTO;
}

export class OpenEndedResultV1 {
  readonly isOpenEndedResultV1OpenEndedResultV1: boolean = true;

  readonly answer: string;
  readonly commonResultBreakdownDetails: CommonResultBreakdownDetails;


  constructor(
  answer: string, 
  commonResultBreakdownDetails: CommonResultBreakdownDetails
  ) {
    this.answer = answer;
    this.commonResultBreakdownDetails = commonResultBreakdownDetails;
  }

  static fromDTO(dto: OpenEndedResultV1DTO): OpenEndedResultV1 {
    const answer = getString(dto, "answer", InvalidOpenEndedResultV1AnswerError);
    const commonResultBreakdownDetails = CommonResultBreakdownDetails.fromDTO(getObject(dto, "commonResultBreakdownDetails", InvalidOpenEndedResultV1CommonResultBreakdownDetailsError));
    return new OpenEndedResultV1(
      answer,
      commonResultBreakdownDetails
    );
  }

  toDTO(): OpenEndedResultV1DTO {
    const dto: OpenEndedResultV1DTO = {
        answer: this.answer,
        commonResultBreakdownDetails: this.commonResultBreakdownDetails.toDTO()
    };
    return dto;
  }
  }

OpenEndedResultV1.prototype.toString = function toString(): string {
  return `OpenEndedResultV1(answer='${this.answer}',commonResultBreakdownDetails='${this.commonResultBreakdownDetails}')`;
};

export class InvalidOpenEndedResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedResultV1Error";
  }
}
export class InvalidOpenEndedResultV1AnswerError extends InvalidOpenEndedResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedResultV1AnswerError";
  }
}

export class InvalidOpenEndedResultV1CommonResultBreakdownDetailsError extends InvalidOpenEndedResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedResultV1CommonResultBreakdownDetailsError";
  }
}
